import React from 'react';
import PrimeSwaggerExplorer from './PrimeSwaggerExplorer';
import PrimeApiPlayground from './PrimeApiPlayground';
import ApiGroupingManagement from './ApiGroupingManagement';

/**
 * Internal Tools > API Documentation — OpenAPI section.
 * API Reference = Swagger UI (schemas, filter, Authorize).
 * API Playground = interactive builder + secure server-side execute.
 */
export default function PrimeApiDocsShell({ initialPanel, docsVersion } = {}) {
  const [panel, setPanel] = React.useState(['playground', 'grouping'].includes(initialPanel) ? initialPanel : 'reference');

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2 border-b border-slate-200">
        {[
          { id: 'reference', label: 'API Reference' },
          { id: 'playground', label: 'API Playground' },
          { id: 'grouping', label: 'API Grouping' },
        ].map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setPanel(tab.id)}
            className={`-mb-px border-b-2 px-3 py-2 text-sm font-semibold ${
              panel === tab.id ? 'border-teal-700 text-teal-900' : 'border-transparent text-slate-500 hover:text-slate-800'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {panel === 'reference' ? <PrimeSwaggerExplorer docsVersion={docsVersion} /> : panel === 'grouping' ? <ApiGroupingManagement /> : <PrimeApiPlayground />}
    </div>
  );
}
